const breakpoints = {
    sm: '340px',
    md: '455px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
}

export default breakpoints;
